module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_pref",
    attrs: {
      "epub:type": "preface",
      "role": "doc-preface"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "role": "doc-pagebreak",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("PREFACE")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "fig-013",
      "src": "images/CH_dingbat_5274_gray.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE INTENT OF THIS WORK IS TWOFOLD:")]), _vm._v(" to select those themes in the New Testament that are of interest to Pentecostals and charismatics and relate these themes to the church. Although the Holy Spirit is the focus of each chapter, the approach will emphasize what the Spirit "), _c('i', [_vm._v("does")]), _vm._v(" rather than on who the Spirit "), _c('i', [_vm._v("is")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Regarding method, "), _c('i', [_vm._v("The Holy Spirit in the New Testament ")]), _vm._v("emphasizes "), _c('i', [_vm._v("praxis")]), _vm._v(" over "), _c('i', [_vm._v("theory")]), _vm._v(". The reader is not only to be biblically informed but also spiritually transformed. The goal is not only to master the content of the Bible but also to hear the voice of the Spirit in the Bible. Thus an overt emphasis on discipleship and spiritual formation will be part of each chapter.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some might feel uncomfortable with comingling serious biblical study with pointed devotional lessons. This sense of unease demonstrates how alienated the academy has become from the church and vice versa. It also shows the need for a more integrated approach of the kind found in "), _c('i', [_vm._v("The Holy Spirit in the New Testament")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These kinds of goals necessarily affect format and writing style. For example, each chapter will open with a key verse that typifies the core message the Spirit plays in this section and creates the spiritual tone for the entire chapter. What follows is a biblically informed treatment of themes that are of particular interest to Pentecostals and charismatics. A brief summary will round out the chapter, which is then followed by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "role": "doc-pagebreak",
      "title": "X"
    }
  }, [_vm._v("the “What does it mean for me?” portion. It is here that the spiritual claims of the text are brought to bear upon the reader. The effectiveness of this section depends on the readiness of the reader to hear what the Spirit is saying through the text.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All of this affects the writing style of "), _c('i', [_vm._v("The Holy Spirit in the New Testament")]), _vm._v(". The text is intended to be read comfortably and devotionally. Apart from introductory matters, the use of secondary sources and footnoting are kept to a minimum. The primary source for the work is the Greek text of the New Testament.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Scriptures serve as the touchstone for the entire work. It is crucial for the reader to look up each citation as he or she studies along. For the sake of continuity, it might be best to read straight through the chapter and then go back and read the supporting texts.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is my sincere hope that "), _c('i', [_vm._v("The Holy Spirit in the New Testament")]), _vm._v(" will not only be a source of biblical knowledge but also a means for personal growth in the Holy Spirit.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A word of gratitude is in store for those Pentecostal scholars who have set such a high standard of excellence. Notables like Gordon Fee, and more recently Craig Keener, come to mind. Such scholars have held together their masterful exegesis of the Word with their heartfelt communion with the Spirit. A special thanks goes out to Paul Conn, president of Lee University. His commitment to academic excellence and to continued faculty development has made this project possible. My stay at Tyndale House in Cambridge, and the constant encouragement of my colleagues there, was of great help to me. Finally, my students are a constant inspiration. They are the church of the future and by all measure, the future is in good hands.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0